export const ModalHead = () => {
   return (
      <>
         <div className="px-11 pt-[30px] mb-4 text-white">
            <p className="text-[22px] font-medium mb-4">Stage Mapping</p>
            <p className="text-[14px] font-medium">
               Tell us how your Follow Up Boss stages or tags match Forward Flow
               stages.
            </p>
            <p className="text-[14px] text-[#B1B1B1]">
               We’ll use this information to track your lead’s journey- updating
               them or listening for changes, so we can take the right actions
               at the right time.
            </p>
         </div>
      </>
   )
}
